// Path: ./src/app/components/ListCard/styled.ts
import { Box, styled as MuiStyled } from "@mui/material";
import styled from "styled-components";

export const RightSideBox = MuiStyled(Box)({
  width: "100%",
  borderRadius: " 5px",
  overflow: "hidden",
  border: "3px solid #9b9b9b",
  maxHeight: 700,
  overflowY: "scroll",
});
export const TopHeadRightBox = styled.div`
  border-bottom: 1px solid #9b9b9b;
  padding-bottom: 2px;
`;
export const TitleHeadRightBox = styled.div`
  font-size: 20px;
  font-weight: 700;
  font-family: sans-serif;
  text-transform: uppercase;
`;
export const SubTitleHeadRightBox = styled.div`
  font-size: 14px;
  font-family: sans-serif;
`;

export const BottomRightBox = styled.div`
  margin-top: 30px;
`;
export const BottomTitleRightBox = styled.div`
  font-size: 20px;
  font-weight: 700;
  font-family: sans-serif;
  text-transform: uppercase;
`;

export const BottomListWrapper = styled.div`
  margin-bottom: 10px;
`;
export const BottomListWithIcon = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  border-bottom: 1px solid #9b9b9b;
  font-weight: 600;
  text-transform: capitalize;
`;

export const BottomList = styled.div`
  border-bottom: 1px solid #9b9b9b;
  padding-left: 30px;
  font-size: 14px;
  padding-top: 6px;
  text-transform: capitalize;
`;
export const UserWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  margin-left: -50px;
  margin-bottom: 20px;
  @media screen and (max-width: 600px) {
    margin-left: -30px;
  }
`;
export const UserName = styled.div`
  font-size: 25px;
  font-family: sans-serif;
  margin-left: 10px;
`;
